export default "__VITE_ASSET__KeAhAS3j__"